<section id="testimonials" class="testimonials-section py-5">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="testimonials-header text-center animate-on-scroll mb-5">
          <span class="section-label d-block">{{ sectionData.label }}</span>
          <h2 class="testimonials-title">{{ sectionData.title }}</h2>
        </div>
      </div>
    </div>

    <div class="row g-4">
      <div 
        class="col-lg-4 col-md-6 col-12"
        *ngFor="let testimonial of testimonials; let i = index"
      >
        <div 
          class="testimonial-card animate-on-scroll h-100"
          [style.transition-delay]="(i * 0.2) + 's'"
        >
          <div class="testimonial-content mb-4">
            <div class="quote-icon">"</div>
            <p class="testimonial-text">{{ testimonial.content }}</p>
          </div>
          
          <div class="testimonial-author d-flex align-items-center">
            <div class="author-avatar me-3">
              <img 
                [src]="testimonial.avatar" 
                [alt]="testimonial.name + ' avatar'"
                loading="lazy"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="author-info">
              <h4 class="author-name mb-1">{{ testimonial.name }}</h4>
              <p class="author-position mb-0">{{ testimonial.position }}</p>
              <p class="author-company mb-0">{{ testimonial.company }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>